import * as React from "react";
import { PropertyFiltersGroupProps } from "../typings";
import { RouteStore } from "bernie-core";
import { UitkSecondaryButton } from "uitk-react-button";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { withStores } from "stores";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkNotificationBadge1 } from "uitk-react-badge";
import { FiltersContext } from "src/stores/PropertyFiltersStore/context/PropertyFiltersContext";
import { PROPERTY_FILTERS } from "../PropertyFilters";
import {
  PropertyFiltersDialog,
  PropertyFilterInDialog,
} from "components/flexComponents/PropertyFilters/dialog/PropertyFiltersDialog";
import { useLocalization } from "@shared-ui/localization-context";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedClickstreamTrackEvent,
} from "components/utility/analytics/FlexAnalyticsUtils";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing } from "uitk-react-spacing";

const ButtonTracked = FlexClickTracker(UitkSecondaryButton);

export const MobilePropertyFilters = withStores("routeStore")((props: { routeStore: RouteStore }) => {
  const context = React.useContext(FiltersContext);
  const { formatText } = useLocalization();

  const onClick = () => {
    props.routeStore.updateSearch({ pwaDialog: "filters" });
  };

  const totalFilter = context.getNumberOfSelectedFilters();

  return (
    <div className="uitk-cell all-cell-1-1 all-b-padding-two">
      <ButtonTracked moduleName={PROPERTY_FILTERS} rfrr="mobileCta" isFullWidth={true} onClick={onClick} icon="tune">
        <>
          <UitkSpacing margin={{ inline: "two" }}>
            <span>{formatText("propertyfilters.filter")}</span>
          </UitkSpacing>
          {totalFilter > 0 && <UitkNotificationBadge1 text={String(totalFilter)} />}
        </>
      </ButtonTracked>
      <PropertyFiltersDialog>
        <div className="SortAndFilters all-x-padding-three">
          {context.getListOfFilters().map((filter, index) => (
            <PropertyFiltersGroup key={`${filter.name}-${index}`} filter={filter} context={context} />
          ))}
        </div>
      </PropertyFiltersDialog>
    </div>
  );
});

/**
 * Represents a filter group (e.g. Popular Filters)
 * @param props
 * @constructor
 */
const PropertyFiltersGroup = (props: PropertyFiltersGroupProps) => {
  const { filter } = props;
  const { formatText } = useLocalization();
  const track = useClickTracker();

  const callback = (filterNameAndShowMoreOrLess: string) => {
    const flexTracking: FlexTrackingInfo = {
      moduleName: PROPERTY_FILTERS,
      rfrr: filterNameAndShowMoreOrLess, // e.g. stars.ShowMore
      action: Action.CLICK,
    };

    sendDelayedClickstreamTrackEvent(flexTracking, track);
  };

  return (
    <UitkExpandoPeek
      collapseHeight={180}
      collapseLabel={formatText("propertyfilter.seeLess")}
      expandLabel={formatText("propertyfilter.seeMore")}
      className="all-t-margin-six all-b-padding-six all-b-margin-six uitk-card-separator-bottom"
      analytics={{
        id: filter!.name,
        callback,
      }}
    >
      <PropertyFilterInDialog {...props} />
    </UitkExpandoPeek>
  );
};
